export const scrollToElement = (panelId: string) => {
    const elem = document.getElementById(panelId);
    if(elem){
        elem.scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
};
